// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"0":"b126087fa220d2c5c15c","794":"4afeb7be0b9db6f70164","924":"ef54bb637927ef9848ff","926":"5e410805c7be0ea5e657"}[chunkId] + ".js";
};